import * as z from 'zod';

const uuidSchema = z.uuid();

export const isUuid = (value: unknown): boolean =>
  uuidSchema.safeParse(value).success;
